function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "circle",
  d: "M16 0c4.4 0 8.2 1.6 11.3 4.7S32 11.6 32 16s-1.6 8.2-4.7 11.3S20.4 32 16 32s-8.2-1.6-11.4-4.7C1.6 24.2 0 20.4 0 16S1.6 7.8 4.6 4.7C7.8 1.6 11.6 0 16 0z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "check",
  d: "M23.8 10.3c-.8-.8-2-.8-2.8 0l-7.1 7.1-2.9-2.8c-.8-.8-2-.8-2.8 0s-.8 2 0 2.8l4.2 4.2c.4.4.9.6 1.5.6.5 0 1.1-.2 1.5-.6l8.5-8.5c.7-.7.7-2-.1-2.8z"
});

var SvgIconCircleCheck2 = function SvgIconCircleCheck2(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default SvgIconCircleCheck2;